import { render } from "./Landings.vue?vue&type=template&id=aeb77bf0&scoped=true"
import script from "./Landings.vue?vue&type=script&lang=js"
export * from "./Landings.vue?vue&type=script&lang=js"

import "./Landings.vue?vue&type=style&index=0&id=aeb77bf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb77bf0"]])

export default __exports__